<template>
    <div class="klass-specifics">
        <h3>Combat Feat</h3>
        <p>As a Fighter, you gain a bonus combat feat</p>
        <div class="content box-shadow text-center">
            <h4 class="ntm">Select a combat feat.</h4>
        </div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            combatFeat: null,
        };
    }
}
</script>


// WEBPACK FOOTER //
// src/components/klasses/Fighter.vue